import React, {useEffect} from "react";
import ReactGA from "react-ga";
import ScrollToTop from "../ScrollToTop";
import styled from "@emotion/styled";
import mapStrToBr from "../../utility/mapStrToBr";
import convertArrayIntoSingleFragment from "../../utility/convertArrayIntoSingleFragment";
import bg from "../../images/case/caseBg.jpg";
import historyImg from "../../images/story/storyHistory.png";
import Bar from "./Bar";
import episodeData from "./data";
// import kv from "../../images/story/kv.jpg"
import Masthead from "../Masthead";

// const Kv = styled.div`
//   width: 100%;
//   height: 100vh;
//   background-image: url(${kv});
//   background-size: cover;
//   background-position: center;
//   position: relative;
// `;

// const KvText = styled.p`
//   width: 100%;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%,-50%);
//   font-weight: 900;
//   font-size: 96px;
//   line-height: 142px;
//   text-align: center;
//   letter-spacing: 0.1em;
//   color: #FFFFFF;
//   @media screen and (max-width: 1024px) {
//     font-size: 60px;
//     line-height: 82px;
//   }
//   @media screen and (max-width: 767px) {
//     font-size: 48px;
//     line-height: 66px;
//   }
//   @media screen and (max-width: 414px) {
//     top: 45%;
//     font-size: 28px;
//     line-height: 48px;
//   }
// `;

const Bg = styled.div`
  width: 100%;
  background-image: url(${bg});
  background-size: 360px;
`;

const Section = styled.section`
  padding: 60px 0px;
  width: 90%;
  max-width: 1080px;
  margin: auto;
  border-left: 0.25px solid rgba(48, 37, 29, 0.1);
  border-right: 0.25px solid rgba(48, 37, 29, 0.1);
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 48px;
  line-height: 71px;
  text-align: center;
  color: #30251D;
  h1 {
    font-weight: 900;
    font-size: 96px;
    line-height: 142px;
    text-align: center;
    letter-spacing: 0.1em;

    color: #FFFFFF;
  }
`;
const Line = styled.div`
  margin-top: 40px;
  &::before {
    content: '';
    width: 40px;
    height: 2px;
    display: block;
    background-color: #30251D;
    margin: auto;
  }
`;

const HistoryBox = styled.div`
  outline: 1px solid #333333;
  width: 100%;
  margin-top: 40px;
  img {
    width: 100%;
  }
`;

const Episode = styled.section`
  width: 100%;
  margin: auto;
  padding: 0;
`;

const EpisodeItem = styled.div`
  width: 100%;
  img {
    width: 100%;
  }
`;

const EpisodeTextContainer = styled.div`
  padding: 60px 0px 200px;
  width: 90%;
  max-width: 1080px;
  margin: auto;
  border-left: 0.25px solid rgba(48, 37, 29, 0.1);
  border-right: 0.25px solid rgba(48, 37, 29, 0.1);
  p {
    font-size: 18px;
    text-align: justify;
    letter-spacing: 0.1rem;
    color: #30251D;
  }
  @media screen and (max-width: 767px) {
    padding: 60px 0px 100px;
  }
`;

const EpisodeTitle = styled.h3`
  font-weight: 500;
  font-size: 26px;
  letter-spacing: 0.1rem;
  color: #000000;
  margin-bottom: 20px;  
`;

const Story = () => {
  useEffect(()=>{
    ReactGA.pageview(`/202012_PRADO/story/`);
    document.title = `TOYOTA Prado - LAND CRUISER品牌故事`;
  }, [])
  return (
    <>
      <ScrollToTop />
      <Masthead ytId={"Gi9hti26AC0"}/>
      {/* <Kv>
        <KvText>
          用近70年的時光<br/>淬鍊出獨一無二的故事 
        </KvText>
      </Kv> */}
      <Bar />
      <Bg>
        <Section id="episode0">
          <Title>LAND CRUISER歷史沿革</Title>
          <Line />
          <HistoryBox>
            <img src={historyImg} alt=""/>
          </HistoryBox>
        </Section>

        <Episode>

          {episodeData.map((items, keys) => {
            const {img, title, text} = items;
            return (
              <EpisodeItem key={keys} id={"episode"+(keys+1)}>
                <img src={img} alt=""/>
                <EpisodeTextContainer>
                  <EpisodeTitle>{title}</EpisodeTitle>
                  <p>{convertArrayIntoSingleFragment(mapStrToBr(text))}</p>
                </EpisodeTextContainer>
              </EpisodeItem>
            )
          })}
          
        </Episode>



      </Bg>
    </>
  )
};

export default Story;